import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

// This is redundant after angular resolves below issue
// https://github.com/angular/angular/issues/13980

@Component({
  selector: 'atx-anchor',
  templateUrl: './anchor.component.html',
  styleUrls: ['./anchor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnchorComponent {
  @Input()
  public href?: string;

  @Input()
  public queryParams?: { [key: string]: string };

  @Input()
  public routerLink?: string[];

  @Input()
  public newTab = false;

  @Input()
  public linkClass = '';

  @Output()
  public linkClick = new EventEmitter();

  public get linkClassList() {
    return `nav-link justify-content-start py-1 px-0 ${this.linkClass}`;
  }

  constructor() {}
}
